import type { StraightenerParameter } from "../../straightener-common/parameterCatalog";

// One editable form cell: target value + optional Min/Max band + select text.
export interface Cell {
	value: string;
	min: string;
	max: string;
	text: string;
}

// Product dimensions are fixed by the product: auto-filled, disabled,
// and saved with the recipe — the operator never enters them.
export const PRODUCT_DIM_CODES = new Set([
	"ProductWidth",
	"ProductHeight",
	"ProductThickness",
]);

// Product dimensions come pre-mapped from the SP (GetProductSizes) — the
// flat-vs-angle geometry rule is server-side, the editor just fills the cells.
export const productDimValues = (
	product?: {
		ProductWidth?: number | null;
		ProductHeight?: number | null;
		ProductThickness?: number | null;
	} | null,
): Record<string, number | null> => ({
	ProductWidth: product?.ProductWidth ?? null,
	ProductHeight: product?.ProductHeight ?? null,
	ProductThickness: product?.ProductThickness ?? null,
});

export const cellKey = (code: string, roll: number) => `${code}:${roll}`;
export const emptyCell = (): Cell => ({
	value: "",
	min: "",
	max: "",
	text: "",
});
export const numOrNull = (s: string): number | null =>
	s.trim() === "" ? null : Number(s);
export const rollsOf = (p: StraightenerParameter, count: number): number[] =>
	p.isPerRoll ? Array.from({ length: count }, (_, i) => i + 1) : [0];
// Roll target/min/max are precise to thousandths (Vert/Axial registers hold
// 1/1000") — cap the UI display at 3 decimals.
export const round3 = (n: number): number => Math.round(n * 1000) / 1000;
export const toStr = (n: number | null, perRoll: boolean): string =>
	n == null ? "" : String(perRoll ? round3(n) : n);
